/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const nf = Intl.NumberFormat();

function ATMServicesGrid({ data }: any) {
  function DescriptionFooterCell(props: any) {
    return (
      <td colSpan={props.colSpan}>
        <span>Total</span>
      </td>
    );
  }

  function TotalSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  function OpenSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  function InRouteSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  function CompletedSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  function PendingSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  function CancelledSumCell(props: any) {
    const field = props.field || "";
    const total = data.reduce((p: any, c: any) => p + c[field], 0);

    return (
      <td className="text-center" colSpan={props.colSpan}>
        {nf.format(total)}
      </td>
    );
  }

  return (
    <Grid data={data}>
      <Column
        field="description"
        title="Service Type"
        width="140px"
        className="grid-cell-font-size"
        footerCell={DescriptionFooterCell}
      />
      <Column
        field="total"
        title="Total"
        width="70px"
        className="grid-cell-font-size text-center"
        format="{0:N0}"
        footerCell={TotalSumCell}
      />
      <Column
        field="open"
        title="Open"
        width="70px"
        className="grid-cell-font-size text-center"
        format="{0:N0}"
        footerCell={OpenSumCell}
      />
      <Column
        field="inRoute"
        title="In Route"
        width="90px"
        className="grid-cell-font-size text-center"
        format="{0:N0}"
        footerCell={InRouteSumCell}
      />
      <Column
        field="completed"
        title="Completed"
        width="110px"
        format="{0:N0}"
        className="grid-cell-font-size text-center"
        footerCell={CompletedSumCell}
      />
      <Column
        field="pending"
        title="Pending"
        width="90px"
        format="{0:N0}"
        className="text-center"
        footerCell={PendingSumCell}
      />
      <Column
        field="cancelled"
        title="Cancelled"
        width="100px"
        className="grid-cell-font-size text-center"
        format="{0:N0}"
        footerCell={CancelledSumCell}
      />
      <Column field="average" title="AST" className="grid-cell-font-size" />
    </Grid>
  );
}

export default ATMServicesGrid;
